import { fromJS } from 'immutable';
import programPaymentTypes, { programPaymentTypesFullNamesMap } from '../../../enums/programPaymentTypes';

export default fromJS({
    paymentsGenerationSettings: {
        programPaymentType: fromJS({ id: Number(programPaymentTypes.partnerPaid), name: programPaymentTypesFullNamesMap[programPaymentTypes.partnerPaid] })
    },
    partners: []
});